<template>
    <td
        :class="{
            'py-1.5 whitespace-nowrap': true,
            'px-6 text-secondary': type === TableCellType.Normal,
            'flex justify-end pr-3 pl-3 sm:pr-6': type === TableCellType.Actions,
            truncate: isTruncated,
        }"
        :style="isTruncated ? `max-width: ${maxWidth};` : ''"
        :title="isTruncated ? title : undefined"
        data-spec-class="table-cell-data"
    >
        <slot />
    </td>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from 'vue';
import { TableCellType } from '@/types';

interface Props {
    type?: TableCellType;
    isTruncated?: boolean;
    maxWidth?: string;
    title?: string;
}

const { type, isTruncated, maxWidth, title } = withDefaults(defineProps<Props>(), {
    type: TableCellType.Normal,
    isTruncated: false,
    maxWidth: '200px',
    title: undefined,
});
</script>
